import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const fetchFacturasPorTipificar = (query) => http.get(`${api}/operacion/facturas-por-tipificar`, { params: { ...query } })

export {
  fetchFacturasPorTipificar
}
